import React from 'react';
import { useSelector } from 'react-redux';
import { Flex } from '@chakra-ui/react';

import { fieldInputTypes } from '../../../../../../../../../../../../../constants/fieldInputTypes';

import FieldInputGroup from './FieldInputGroup';

function RequiredCoverageFieldTypeInputs({ useFormMethods, blueprint }) {
  const selectedPropertyFieldTypes = useSelector(blueprint.selectSelectedPolicyPropertyFieldTypes);

  if (selectedPropertyFieldTypes?.length) {
    return (
      <Flex direction="column" justifyContent="space-between">
        {
          selectedPropertyFieldTypes.map(id => {
            switch (id) {
              case fieldInputTypes.Checkboxes:
                return (
                  <FieldInputGroup
                    blueprint={blueprint}
                    fieldInputType={fieldInputTypes.Checkboxes}
                    key={id}
                    useFormMethods={useFormMethods}
                  />
                );
              case fieldInputTypes.Monetary:
                return (
                  <FieldInputGroup
                    blueprint={blueprint}
                    fieldInputType={fieldInputTypes.Monetary}
                    key={id}
                    useFormMethods={useFormMethods}
                  />
                );
              case fieldInputTypes.AlphaNumeric:
                return (
                  <FieldInputGroup
                    blueprint={blueprint}
                    fieldInputType={fieldInputTypes.AlphaNumeric}
                    key={id}
                    useFormMethods={useFormMethods}
                  />
                );
              default:
                return <></>;
            }
          })
        }
      </Flex>
    );
  }

  return <></>;
}

export default RequiredCoverageFieldTypeInputs;
